export const documents = {
  refresh: 'documents-refreshed',
  folders: 'document-folders-list-received',
  list: 'documents-full-list-received',
  dir: 'documents-folder-content-received',
  rsp: 'documents-for-rsp-received',
  get: 'document-content-received',
  read: 'local-document-loaded',
  post: 'new-document-created',
  update: 'document-updated'
}
